// Mirrors the backend FILE_UPLOAD_MAX_SIZE_BYTES setting. Keep in sync.
export const MAX_UPLOAD_BYTES = 2 * 1024 * 1024 * 1024;

export function formatUploadSize(bytes: number): string {
  if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
  if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
  if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${bytes} B`;
}

export function getUploadSizeError(fileName: string, totalBytes: number): string | null {
  if (totalBytes <= MAX_UPLOAD_BYTES) return null;
  return (
    `"${fileName}" is ${formatUploadSize(totalBytes)} which exceeds the ` +
    `maximum upload size of ${formatUploadSize(MAX_UPLOAD_BYTES)}.`
  );
}
